import { Size } from "store/types/previewImage";

export const formatBytes = (bytes: number): Size => {
    let marker = 1024; // Change to 1000 if required
    let decimal = 2; // Change as required
    let kiloBytes = marker; // One Kilobyte is 1024 bytes
    let megaBytes = marker * marker; // One MB is 1024 KB
    let gigaBytes = marker * marker * marker; // One GB is 1024 MB

    // return bytes if less than a KB
    if (bytes < kiloBytes) return `${bytes} B`;
    // return KB if less than a MB
    else if (bytes < megaBytes)
        return `${Number((bytes / kiloBytes).toFixed(decimal))} KB`;
    // return MB if less than a GB
    else if (bytes < gigaBytes)
        return `${Number((bytes / megaBytes).toFixed(decimal))} MB`;
    // return GB if less than a TB
    else return `${Number((bytes / gigaBytes).toFixed(decimal))} GB`;
};
